import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, shareReplay } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PaEncryptionService {
    constructor(private readonly http: HttpClient) {}

    encryptSensitiveValue(value: string, projectId: number): Observable<string> {
        return this.http
            .post<string>(
                `/rest/paDataSet/encryptSensitiveValue`,
                {
                    encryptionString: value,
                    key: ''
                },
                {
                    params: { projectId: projectId.toString() },
                    responseType: 'text' as 'json'
                }
            )
            .pipe(shareReplay({ refCount: true, bufferSize: 1 }));
    }
}
